import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import { FC, useMemo } from 'react'

import { Binance } from './Binance'
import { SmartBCH } from './SmartBCH'
import { SmartBCHAmber } from './SmartBCHAmber'

const NETWORK_ICON: Record<number, (props: React.ComponentProps<'svg'>) => JSX.Element> = {
  [ChainId.SMARTBCH]: SmartBCH,
  [ChainId.SMARTBCH_TESTNET]: SmartBCHAmber,
  [ChainId.BSC]: Binance,
  [ChainId.BSC_TESTNET]: Binance,
}

export const NetworkIcon: FC<any> = ({ chainId, ...props }: any) => {
  const Icon = useMemo(() => {
    return NETWORK_ICON[chainId]
  }, [chainId])

  if (Icon) return <Icon {...props} />
  return <></>
}
